import { Injectable, NgZone } from '@angular/core';
import { Network } from '@capacitor/network';
import { Observable, TimeoutError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { takeUntil, timeout } from 'rxjs/operators';
import { timer } from 'rxjs';
import { Queue } from '@ildes/utils/fifo';

export const CONNECTED = 0;
export const NO_CONNECTION = 1;
export const LIMITED_CONNECTION = 2;
export const RECONNECTING = 3;

const EVENT_OK = 0;
const EVENT_TIMEOUT = 1;
const TIMEOUT = 2 * 1000;
const MAX_RETRIES = 1;
const OFFSET = 1 * 1000;

export class Status {
  public state: Number;
  public reconnecting: Boolean;
  public seconds: Number;
  constructor(
    state: Number,
    reconnecting: Boolean,
    seconds: Number,
  ) {
    this.state = state;
    this.reconnecting = reconnecting;
    this.seconds = seconds;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ConnectionStateService {

  public statusObserver: Observable<{state: Status}>;

  log: string[];
  private status: Number;
  private reconnecting;
  private statusSubscriber;
  private timeout = TIMEOUT;
  private maxRetries = MAX_RETRIES;
  private offset = OFFSET;
  private retryCall = null;
  private retries = 0;
  private currentRequests = [];
  private queue = new Queue(5);
  private interval;
  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {
    this.status = CONNECTED;
    this.statusObserver = new Observable(subscriber => {
      this.statusSubscriber = subscriber;
      Network.getStatus().then(this.updateStatus.bind(this));
    });

    Network.addListener('networkStatusChange', (status) => {
      this.zone.run(() => {
        this.updateStatus(status);
      });
    });
  }

  private performInterval() {
    if (this.interval) {
      return;
    }
    this.interval = setInterval(() => {
      this.updateTimeout();
    }, 1000);
  }

  private updateTimeout() {
    if(!this.currentRequests?.length && this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.currentRequests.map((cr) => {
      const time =  performance.now() - cr.timestamp;

      if (time > 4000) {
        this.queue.push(EVENT_TIMEOUT);
        cr.timestamp = 0;
        console.log('log ', 'empieza a ser sospechoso');
      }
    });
    this.currentRequests = this.currentRequests.filter((cr)=> cr.timestamp > 0);

    this.updateStatusFromQueue();
  }

  private updateStatus(status) {
    console.log('[service] update status', status);
    if (!this.statusSubscriber) {
      return;
    }
    this.queue.clear();
    if (status.connected) {
      if (this.status !== CONNECTED) {
        this.status = RECONNECTING;
        this.reconnecting = true;
        this.test();
      } else {
        this.reconnecting = false;
        this.status = CONNECTED;
      }
    } else {
      this.reconnecting = false;
      this.status = NO_CONNECTION;
    }

    this.statusSubscriber.next({ state: new Status(this.status, this.reconnecting, 0)});
  }

  public update(status) {
    this.status = status;
    if (!this.statusSubscriber) {
      return;
    }

    this.statusSubscriber.next({ state: new Status(this.status, this.reconnecting, 0)});
  }

  public testConnection() {
    if (this.reconnecting) {
      return;
    }
    this.reconnecting = true;
    this.test();
  }

  private test() {
    console.log('[service] try reconnect', this.status, this.reconnecting, this.retries);
    if (this.retries >= this.maxRetries) {
      this.reconnecting = false;
      this.updateStatusFromQueue();
      this.retries = 0;
      return;
    }
    if (this.retryCall) {
      return;
    }

    this.retryCall = this.reconnect().subscribe(() => {
      this.queue.push(EVENT_OK);
    }, (e) => {
      if (e instanceof TimeoutError) {
        this.queue.push(EVENT_TIMEOUT);
      }
    }).add(() => {
      this.retries += 1;
      this.retryCall = null;
      setTimeout(() => {
        this.test();
      }, this.offset);
    });
  }

  private reconnect() {
    return this.http.get('https://jsonplaceholder.typicode.com/todos/1')
    .pipe(
      timeout(this.timeout)
    );
  }

  public pushRequest(req) {
    this.currentRequests = [...this.currentRequests, {req, timestamp: performance.now()}];

    this.performInterval();
  }

  public removeRequest(req, timeout, ignoreQueue = false) {
    this.currentRequests = this.currentRequests.filter((creq) => {
      if (creq.req !== req) {
        return true;
      } else {
        if (!ignoreQueue) {
          this.queue.push(timeout ? EVENT_TIMEOUT: EVENT_OK);
        }
        return false;
      }
    });
    
  }

  private updateStatusFromQueue() {
    if(this.status === NO_CONNECTION) {
      return;
    }
    const timeouts = this.queue.items.filter((event) => event === EVENT_TIMEOUT).length;
    if(timeouts > this.queue.size()/2 || this.queue.last() === EVENT_TIMEOUT) {
      this.update(LIMITED_CONNECTION);
    } else if(this.queue.last() === EVENT_OK){
      this.update(CONNECTED);
    }
  }
}
